//TODO: DELETE THIS FILE AFTER EXPERIMENT IS MERGED

import createReactClass from 'create-react-class';
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import * as Symbols from '@wix/santa-editor-symbols';
import { translate } from '#packages/i18n';

import { AutoComplete, Input, listItemSelectBuilder } from '@wix/design-system';

import * as core from '#packages/core';
import * as util from '#packages/util';
import * as stateManagement from '#packages/stateManagement';
import * as coreBi from '#packages/coreBi';
import constants from '#packages/constants';
import * as BaseUI from '#packages/baseUI';
import { cx } from '#packages/util';
import type { TpaInnerRouteData } from '#packages/stateManagement';
import type { SitemapEntry } from 'types/documentServices';
import type { FullDynamicPagesComboBoxProps } from './dynamicPagesComboBox';
import { INFRA } from './dynamicPagesComboBox';

const isNewWorkspace = util.workspace.isNewWorkspaceEnabled();

const EXCLUDED_CLASSNAMES_FROM_DRAG = [
  'button-content',
  'tooltip-on-ellipsis-content',
  'combo-box-wrapper',
  'c1',
  'selected-content',
  'symbol-close',
  'close-area',
  'selected-container',
  'symbol-arrow-down',
];

const MAX_HEIGHT_PIXELS_DROPDOWN = '335';

type InnerRoute = SitemapEntry | TpaInnerRouteData;

function startsWithCaseInsensitive(a = '', b = '') {
  if (a === undefined) {
    return;
  }
  return !b || a.toLowerCase().startsWith(b.toLowerCase());
}

const NewDynamicPageComboBoxPure =
  // eslint-disable-next-line react/prefer-es6-class
  createReactClass<FullDynamicPagesComboBoxProps>({
    displayName: 'dynamicPagesComboBox',
    render() {
      return this.shouldShowInnerRoutesDropDown()
        ? (() => {
            return (
              <div
                key="dynamicPageComboBox"
                className={cx(
                  'new-dynamic-pages-combo-box',
                  'no-manage-button',
                )}
                style={
                  this.state.isCustomPosition
                    ? _.omit(this.props.style, ['top', 'left'])
                    : this.props.style
                }
                onMouseDown={(e) => {
                  const { classList } = e.target as HTMLDivElement;
                  if (
                    !EXCLUDED_CLASSNAMES_FROM_DRAG.some(
                      (className) =>
                        classList.contains(className) || classList.length === 0,
                    )
                  ) {
                    this.startDrag(e, this.getDragLimits());
                  }
                }}
                onMouseUp={() => {
                  this.endDrag();
                }}
              >
                <div className="dragable-area">
                  {isNewWorkspace ? (
                    <Symbols.symbol name="dragHandler" />
                  ) : (
                    <BaseUI.symbol
                      name="smalldragHandle"
                      className="symbol-smallDragHandle"
                    />
                  )}
                </div>
                <div className={cx('new-combo-box-wrapper')}>
                  <AutoComplete
                    dataHook="dynamic-pages-combo-auto-complete"
                    value={
                      this.state.userTyping ?? this.state.currentProductName
                    }
                    size="small"
                    maxHeightPixels={MAX_HEIGHT_PIXELS_DROPDOWN}
                    textOverflow="ellipsis"
                    suffix={
                      <Input.Affix>
                        {translate('Platform_Sausage_OOI_Number_of_Items', {
                          Num_Items: this.props.innerRoutes.length,
                        })}
                      </Input.Affix>
                    }
                    key="innerRouteDropDown"
                    onSelect={(e) => {
                      this.sendBI(
                        coreBi.events.dynamicPageComboBox.item_selected,
                        this.getBIParams(e.id),
                      );
                      if (e.id === this.props.selectedInnerRoute) {
                        this.setState({ userTyping: undefined });
                      } else {
                        this.props.setSelectedInnerRoute(
                          e.id,
                          this.props.routerId,
                        );
                      }
                    }}
                    onBlur={() => {
                      if (this.state.userTyping !== undefined) {
                        // Use a timeout to avoid flickering caused by rapid updates when switching inner routes
                        setTimeout(() => {
                          this.setState({ userTyping: undefined });
                        }, 0);
                      }
                    }}
                    onInputClicked={() => {
                      this.sendBI(
                        coreBi.events.dynamicPageComboBox.click,
                        this.getBIParams(this.state.selectedRouteValue),
                      );
                    }}
                    className="new-dynamic-pages-combobox"
                    options={this.state.routesOptions}
                    selectedId={this.state.currentProductName}
                    onChange={(obj) => {
                      this.setState({ userTyping: obj.target.value });
                    }}
                    predicate={(option) =>
                      startsWithCaseInsensitive(
                        option.label?.trim(),
                        this.state.userTyping?.trim(),
                      )
                    }
                  />
                </div>
              </div>
            );
          })()
        : null;
    },
    mixins: [core.mixins.editorAPIMixin, util.draggableMixin],
    getInitialState() {
      return {
        shouldShowNavigation: true,
        rangeStartIndex: 0,
        userTyping: undefined,
      };
    },
    propTypes: {
      previewMode: PropTypes.bool.isRequired,
      editorIsInit: PropTypes.bool.isRequired,
      devModeContext: PropTypes.object.isRequired,
      stageLayout: PropTypes.object,
      innerRoutes: PropTypes.array.isRequired,
      selectedInnerRoute: PropTypes.string,
      routerId: PropTypes.string,
      setSelectedInnerRoute: PropTypes.func.isRequired,
      style: PropTypes.object,
    },
    componentDidMount() {
      this.setState({
        routesOptions: this.getInnerRoutesDropDownOptions(
          this.props.innerRoutes,
        ),
      });
    },
    componentDidUpdate(prevProps) {
      if (
        !this.props.editorIsInit ||
        !this.props.selectedInnerRoute ||
        _.isEmpty(this.props.innerRoutes) ||
        this.isCollectionPageOrHasOneRoute()
      ) {
        return;
      }

      if (
        this.props.routerId !== prevProps.routerId ||
        !_.isEqual(prevProps.tpaInfo, this.props.tpaInfo) ||
        !_.isEqual(prevProps.innerRoutes, this.props.innerRoutes)
      ) {
        this.setState({
          shouldShowNavigation: true,
        });
      }

      if (
        this.props.routerId !== prevProps.routerId ||
        !_.isEqual(prevProps.innerRoutes, this.props.innerRoutes)
      ) {
        this.sendBI(
          coreBi.events.dynamicPageComboBox.show,
          this.getBIParams(this.props.selectedInnerRoute),
        );
      }

      if (this.props.selectedInnerRoute !== prevProps.selectedInnerRoute) {
        const index = this.findInnerRouteIndex(
          this.props.selectedInnerRoute,
          this.props.innerRoutes,
        );
        const newRouteValue = this.getInnerRouteUrl(
          this.props.innerRoutes[index],
        );
        this.setState({
          selectedRouteValue: newRouteValue,
          currentProductName: this.getCurrentProductName(newRouteValue),
          userTyping: undefined,
          clearUserTyping: false,
        });
      }

      if (prevProps.innerRoutes !== this.props.innerRoutes) {
        this.setState({
          routesOptions: this.getInnerRoutesDropDownOptions(
            this.props.innerRoutes,
          ),
        });
      }
    },
    shouldComponentUpdate(nextProps, nextState) {
      return (
        !_.isEqual(this.state, nextState) || !_.isEqual(this.props, nextProps)
      );
    },
    getCurrentProductName(selectedRouteValue: string) {
      const matchedItem = this.props.innerRoutes?.find(
        (item: any) => (item.path ?? item.url) === selectedRouteValue,
      );
      return (matchedItem as any)?.title ?? (matchedItem as any)?.name;
    },
    isCollectionPageOrHasOneRoute() {
      const { innerRoutes } = this.props;
      if (!innerRoutes) {
        return false;
      }
      return innerRoutes.length === 1;
    },
    shouldShowInnerRoutesDropDown() {
      const editorAPI = this.getEditorAPI();
      const developerContext = editorAPI.dsRead?.pages.getFocusedPageId
        ? editorAPI.developerMode.getContext()
        : {};
      const isPageContext =
        developerContext.type === constants.DEVELOPER_MODE.CONTEXT_TYPES.PAGE;
      const isShowingFixedComponentsEnabled = editorAPI.dsRead?.documentMode
        ? editorAPI.dsRead.documentMode.isShowingFixedComponentsEnabled()
        : true;
      const isThePageFocused = editorAPI.dsRead?.pages.getFocusedPageId
        ? editorAPI.dsRead.pages.getFocusedPageId() ===
          editorAPI.dsRead.pages.getPrimaryPageId()
        : true;
      return (
        isThePageFocused &&
        !this.isCollectionPageOrHasOneRoute() &&
        this.state.shouldShowNavigation &&
        (this.props.routerId || this.props.tpaInfo) &&
        !_.isEmpty(this.props.innerRoutes) &&
        (this.props.previewMode || isPageContext) &&
        isShowingFixedComponentsEnabled
      );
    },
    getInnerRouteUrl(innerRoute: InnerRoute) {
      if (this.props.routerId) {
        return (innerRoute as SitemapEntry).url;
      }
      return (innerRoute as TpaInnerRouteData).path;
    },
    getInnerRoutesDropDownOptions(innerRoutes: InnerRoute[]) {
      return innerRoutes.map((innerRoute) => {
        const innerRouteUrl = this.getInnerRouteUrl(innerRoute);
        const innerRouteName =
          (innerRoute as SitemapEntry).title ??
          (innerRoute as TpaInnerRouteData).name;

        return listItemSelectBuilder({
          id: innerRouteUrl,
          label: innerRouteName,
          title: innerRouteName,
          size: 'small',
        });
      });
    },
    sendBI(eventName: AnyFixMe, params: AnyFixMe) {
      const editorAPI = this.getEditorAPI();
      editorAPI.bi.event(eventName, params);
    },
    getBIParams(innerRouteName: string) {
      const editorAPI = this.getEditorAPI();
      const currentPageId = editorAPI.dsRead.pages.getPrimaryPageId();
      const routerData =
        editorAPI.dsRead.routers.getRouterDataForPageIfExist(currentPageId);
      if (routerData) {
        return {
          item_path: innerRouteName,
          item_id: routerData.prefix,
          app_id: routerData.appDefinitionId,
          infra: INFRA.DYNAMIC_PAGES,
        };
      }

      const state = editorAPI.store.getState();
      const selectedRoute =
        stateManagement.tpaDynamicPages.selectors.getSelectedRouteInfo(state);
      const currentTpa =
        stateManagement.tpaDynamicPages.selectors.getCurrentRouteInfo(state);
      return {
        item_path: innerRouteName,
        item_id: selectedRoute.itemTypeIdentifier,
        app_id: currentTpa.appDefinitionId,
        infra: INFRA.TPA_LINKS,
      };
    },
    openHelpCenter() {
      const editorAPI = this.getEditorAPI();
      const helpId = 'b853c294-8ff1-418f-b4d2-29d7b59a85c3'; // TODO: change helpid
      const biHelpParams = {
        origin: 'display-combo-box',
        panel_name: 'dynamic-pages-display-combo-box',
        component: this.props.id,
      };

      editorAPI.panelManager.openHelpCenter(helpId, null, biHelpParams);
    },
    findInnerRouteIndex(innerRoute: string, innerRoutes: InnerRoute[]) {
      let index = innerRoutes.findIndex(
        (route) => this.getInnerRouteUrl(route) === innerRoute,
      );
      if (index === -1) {
        const decoded = decodeURIComponent(innerRoute);
        index = innerRoutes.findIndex(
          (route) => this.getInnerRouteUrl(route) === decoded,
        );
      }
      return index === -1 ? 0 : index;
    },
    moveToItem(index: AnyFixMe) {
      const newRoute =
        !_.isEmpty(this.props.innerRoutes) &&
        index < this.props.innerRoutes.length
          ? this.getInnerRouteUrl(this.props.innerRoutes[index])
          : null;
      this.props.setSelectedInnerRoute(newRoute, this.props.routerId);
    },
    getDragLimits() {
      let { stageLayout } = this.props;

      if (!stageLayout || this.props.isPreview) {
        stageLayout = window.document.body.getBoundingClientRect();
      }

      if (util.fixedStage.isFixedStageEnabled()) {
        return {
          x: [stageLayout.x, stageLayout.right],
          y: [
            stageLayout.top - constants.UI.FIXED_STAGE_MARGIN_TOP,
            stageLayout.bottom,
          ],
        };
      }

      return {
        x: [stageLayout.left, stageLayout.right],
        y: [stageLayout.top, stageLayout.bottom],
      };
    },
    onDragStart() {
      this.props.onDragStart?.();
    },
    onDragEnd() {
      this.props.onDragEnd?.();
    },
  });

export default NewDynamicPageComboBoxPure;
